import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { House, Notebook, User, Users } from '@phosphor-icons/react';
import { motion } from 'framer-motion';
import { useAuth } from '../context/AuthContext';
import MobileOTPLogin from './MobileOTPLogin';

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useAuth();
  const [showLoginModal, setShowLoginModal] = useState(false);

  // Define navigation items based on login status
  const navItems = isAuthenticated ? [
    { 
      id: 'home', 
      label: 'Home', 
      icon: House, 
      path: '/', 
      onClick: () => navigate('/') 
    },
    { 
      id: 'bookings', 
      label: 'Bookings', 
      icon: Notebook, 
      path: '/user/dashboard/bookings', 
      onClick: () => navigate('/user/dashboard/bookings')
    },
    { 
      id: 'passengers', 
      label: 'Passengers', 
      icon: Users, 
      path: '/user/dashboard/passengers', 
      onClick: () => navigate('/user/dashboard/passengers')
    },
  ] : [
    { 
      id: 'home', 
      label: 'Home', 
      icon: House, 
      path: '/', 
      onClick: () => navigate('/') 
    },
    { 
      id: 'login', 
      label: 'Login', 
      icon: User, 
      path: null, 
      onClick: () => setShowLoginModal(true)
    },
  ];

  const isActive = (path) => {
    if (!path) return false;
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <>
      <nav 
        className="md:hidden fixed bottom-0 left-0 right-0 h-16 bg-white/95 backdrop-blur-xl border-t border-gray-200 flex justify-around items-center z-[100] pb-safe shadow-[0_-4px_10px_rgba(0,0,0,0.08)]"
        data-testid="bottom-navigation"
        style={{ 
          position: 'fixed',
          backgroundColor: 'rgba(255, 255, 255, 0.98)',
        }}
      >
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          
          return (
            <motion.button
              key={item.id}
              onClick={item.onClick}
              className={`flex flex-col items-center justify-center ${
                navItems.length === 4 ? 'min-w-[70px]' : 'min-w-[80px]'
              } flex-1 relative transition-colors ${
                active ? 'text-[#1B375B]' : 'text-gray-400'
              }`}
              whileTap={{ scale: 0.9 }}
              data-testid={`nav-${item.id}`}
            >
              {active && (
                <motion.div
                  layoutId="activeTab"
                  className="absolute -top-0.5 left-1/2 -translate-x-1/2 w-12 h-1 bg-[#1B375B] rounded-full"
                  transition={{ type: 'spring', stiffness: 500, damping: 30 }}
                />
              )}
              <Icon size={24} weight={active ? 'fill' : 'regular'} className="mb-1" />
              <span className="text-xs font-medium">{item.label}</span>
            </motion.button>
          );
        })}
      </nav>

      {/* Mobile OTP Login Modal */}
      <MobileOTPLogin 
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
        onSuccess={(userData) => {
          console.log('Login successful:', userData);
          setShowLoginModal(false);
        }}
      />
    </>
  );
};

export default BottomNav;